<h1 mat-dialog-title>{{tituloDialog}}</h1>
<form>
  <div mat-dialog-content class="calibrates-theme">
 
    <div fxLayout="row" class="flexwrap">

      @if (!data.isDisabled) {
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.equipment.equipment.label' | translate }}</mat-label>
            <input matInput [(ngModel)]="data.equipment.internalId" [ngModelOptions]="{standalone: true}" #trigger="matAutocompleteTrigger" [matAutocomplete]="auto"
              placeholder="{{ 'protocolEdit.dialog.equipment.name.label' | translate }}"
              (keyup)="lookupEquipment($event)" required>
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn"
              (optionSelected)="onEquipmentChange($event, trigger)">
              @for (item of equipmentAutoComplete; track item; let index = $index) {
                <mat-option [value]="item">
                  {{ item.name}} ({{item.serialNum}})
                </mat-option>
              }
            </mat-autocomplete>
            <mat-error>
              {{ 'protocolEdit.dialog.equipment.equipment.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      }

      @if (!data.isDisabled) {
        <div fxFlex>
          <a class="under-card-link" style="cursor: pointer;margin: inherit;" (click)="createEquipment()">
            {{ 'calibrateEquipmentEdit.general.equipment.notExists' | translate }}
          </a>
        </div>
      }

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.equipment.label' | translate }}</mat-label>
          <input matInput name="name" disabled
            [ngModel]="data.equipment.equipment" [disabled]="true">
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.maker.label' | translate }}</mat-label>
          <input matInput
            name="maker" [disabled]="true" [ngModel]="data.equipment.maker" [errorStateMatcher]="matcher">
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.maker.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div> 

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.model.label' | translate }}</mat-label>
          <input matInput
            name="model" [disabled]="true" [ngModel]="data.equipment.model" [errorStateMatcher]="matcher">
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.model.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.serialNum.label' | translate }}</mat-label>
          <input matInput
            name="serialNum" [disabled]="true" [ngModel]="data.equipment.serialNum" [errorStateMatcher]="matcher">
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.serialNum.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.internalId.label' | translate }}</mat-label>
          <input matInput
            name="internalId" [disabled]="true" [ngModel]="data.equipment.internalId" [errorStateMatcher]="matcher">
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.internalId.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'protocolEdit.dialog.equipment.location.label' | translate }}</mat-label>
          <input matInput
            name="location" [disabled]="true" [ngModel]="data.equipment.location" required [errorStateMatcher]="matcher">
          <mat-error>
            {{ 'protocolEdit.dialog.equipment.location.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

    </div>

  </div>
  <div mat-dialog-actions class="calibrates-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>